/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";

// MaterialReactTable
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";

//import translation function for language translation
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";

const FIELD_TO_PARAM = {
  name: "name",
  description: "description",
  startdate: "startdate",
  enddate: "enddate",
};

const CourseListArea = ({ downloadExcel }) => {
  const { t } = useTranslation(); //for translation

  const token = localStorage.getItem("token");

  const { reloadCourseList, setReloadCourseList, setEditCourseData, screenHeight} =
    useContext(GlobalProvider);

  // default user data ------------------------------------
  const [courseList, setCourseList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterTimer = useRef(null);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return courseList.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : courseList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Courses.xlsx");
  };

  // allow edit of click record --------------------
  const showEditPopup = (courseData) => {
    setEditCourseData(courseData);
    new bootstrap.Offcanvas(document.getElementById("addBatchPopup")).toggle();
  };

  /* custom name html */
  const nameHTML = ({ dataItem }) => {
    return (
      <div className="kendoCustomColumn overflow-visible">
        <div className="d-flex align-items-center gap-2">
          <p className="d-flex gap-2 align-items-center text-nowrap">
            <span className="d-block">{dataItem.name}</span>
          </p>

          <div className="dropdown cell-dropdown ms-auto">
            <button
              className=" bg-transparent p-0 border-0"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="d-block material-symbols-outlined">
                more_vert
              </span>
            </button>
            <ul className="dropdown-menu border-0 shadow-lg ">
              <li>
                <Link
                  className="dropdown-item text-dark ms-3"
                  to="#"
                  onClick={() => {
                    showEditPopup(dataItem);
                  }}
                >
                  {t("Edit")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  };

  // Column definitions
  const tableColumns = useMemo(() => [
    {
      id: "name",
      accessorKey: "name",
      header: t("Name"),
      Cell: ({ row }) => nameHTML({ dataItem: row.original }),
      size: 200,
    },
    {
      id: "description",
      accessorKey: "description",
      header: t("Comments"),
      size: 200,
    },
    {
      id: "startdate",
      accessorKey: "startdate",
      header: t("Start Date"),
      size: 200,
    },
    {
      id: "enddate",
      accessorKey: "enddate",
      header: t("End Date"),
      size: 200,
    },
  ], [courseList]);

  //function for get all course lists
  const getAllCourseList = async (currentColumnFilters = columnFilters) => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_COURSE + `?token=${token}`;

      currentColumnFilters.forEach(({ id, value }) => {
        const param = FIELD_TO_PARAM[id];
        if (param && value?.toString().trim()) {
          requestUrl += `&${param}=${encodeURIComponent(value.toString().trim())}`;
        }
      });

      const response = await getData(requestUrl);

      if (response.status) {
        setCourseList(response.data);
        setResponseReceived(true);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    if (reloadCourseList) {
      getAllCourseList();
      setReloadCourseList(false);
    }
  }, [reloadCourseList]);

  useEffect(() => {
    if (responseReceived === false) {
      getAllCourseList();
    }
  }, [responseReceived]);

  /* hook to hit exportExcel() function */
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* column filter — debounced API call */
  useEffect(() => {
    clearTimeout(columnFilterTimer.current);
    columnFilterTimer.current = setTimeout(() => {
      getAllCourseList(columnFilters);
    }, 500);
  }, [columnFilters]);

  return (
    <div className="table-responsive">
      <MaterialReactTable
        columns={tableColumns}
        data={courseList}
        enableSorting
        enableFilters
        enableGlobalFilter={false}
        manualFiltering
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        onColumnFiltersChange={setColumnFilters}
        getRowId={(row) => row._id}
        state={{ rowSelection, columnFilters }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
        initialState={{
          pagination: { pageSize: 100, pageIndex: 0 },
          showColumnFilters: true,
        }}
      />
    </div>
  );
};

export default CourseListArea;
